import Cookies from "js-cookie";
import { getAnonymousID } from "@/scripts/oauth.js";

export const callApi = (method, url, data, isTiesApi = true) => {
    const option = {
        method: method,
        headers: header({ "Content-Type": "application/json" }),
        // credentials: "include",
        body: data ? JSON.stringify(data) : null,
    };
    return call(option, url, isTiesApi);
};

function appendFormData(formData, data, parentKey = "") {
    if (data === null || data === undefined) return;

    if (Array.isArray(data)) {
        data.forEach((value, index) => {
            const key = parentKey ? `${parentKey}[${index}]` : index;
            appendFormData(formData, value, key);
        });
    } else if (typeof data === "object" && !(data instanceof File)) {
        Object.keys(data).forEach((key) => {
            const value = data[key];
            const newKey = parentKey ? `${parentKey}[${key}]` : key;
            appendFormData(formData, value, newKey);
        });
    } else {
        formData.append(parentKey, data);
    }
}

export const callFormdata = (method, url, data, isTiesApi = true) => {
    const formData = new FormData();
    console.log('callFormdata data', data);
    appendFormData(formData, data);
    const option = {
        method: method,
        headers: header(),
        // credentials: "include",
        body: formData,
    };
    return call(option, url, isTiesApi);
};



export const formPost = (url, data, indocument) => {
    const doc = indocument || document;
    const form = doc.createElement("form");
    form.style.display = "none";
    form.action = url;
    form.method = "post";
    for (let item of Object.entries(data)) {
        const input = doc.createElement("input");
        input.type = "hidden";
        input.name = item[0];
        input.value = item[1];
        form.appendChild(input);
    }
    doc.body.appendChild(form);
    form.submit();
    doc.body.removeChild(form);
};

export const callSamApi = (method, url, data) => {
    return callApi(method, "https://" + process.env.VUE_APP_SAMDomain + url, data, false);
};

const header = (data) => {
    return {
        ...data,
        "X-Current-URL": window.location.href,
        Authorization: `Bearer ${Cookies.get("auth_token")}`,
        AID: getAnonymousID(),
    };
};

const call = async (option, url, isTiesApi = true) => {
    const u = isTiesApi ? "https://" + process.env.VUE_APP_APIDomain + url : url;
    return fetch(u, option).then((response) => {
        if (isTiesApi) {
            const refreshedToken = response.headers.get("X-Refreshed-Token");
            if (refreshedToken) {
                Cookies.set("auth_token", refreshedToken, { expires: 7 });
            }
        }
        return response.ok ? response.json() : Promise.reject(response);
    });
};
